<form [formGroup]="addNewUserForm" (ngSubmit)="onSubmit()">

    <acabim-form-block labelWidth="10" [labelAlign]="'right'">

        <acabim-form-input-wrapper>
            <acabim-form-input-label>{{type | titlecase}}</acabim-form-input-label>
            <acabim-form-input-content>
                <input type="text" formControlName="detail">
                <p-dropdown [options]="addDataOptions" optionLabel="label" formControlName="type"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>

        <acabim-form-input-wrapper>
            <acabim-form-input-label>Make default</acabim-form-input-label>
            <acabim-form-input-content>
                <input type="checkbox" formControlName="default">
            </acabim-form-input-content>
        </acabim-form-input-wrapper>

    </acabim-form-block>

    <div class="cas-action-buttons">
        <button type="submit" [disabled]="!addNewUserForm.valid" class="cas-button-action">Add</button>
        <button type="button" (click)="onClose()">Cancel</button>
    </div>

</form>
